import React, { useState } from "react";
import { Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import { Map } from "immutable";

import TableauViz from "../components/TableauViz.react";
import OrganizationStore from "../stores/OrganizationStore";

export const FilterableTableauViz = ({
  view,
  /** @type {Map} */ filterOptions = null,
  tableauOptions = null,
}) => {
  if (!filterOptions || filterOptions.isEmpty()) {
    return <TableauViz view={view} tableauOptions={tableauOptions} />;
  }

  return (
    <FilteredTableauViz
      view={view}
      filterOptions={filterOptions}
      tableauOptions={tableauOptions}
    />
  );
};

export const FilteredTableauViz = (
  /** @type {{filterOptions: Map}}*/ {
    view,
    filterOptions = null,
    tableauOptions = null,
  }
) => {
  // Filter to only organizations that the user has access to
  const accessibleFilterOptions = filterOptions.filter(
    (v) => !!OrganizationStore.get(parseInt(v.get("orgId", "-1")), null)
  );

  const [selectedFilterKey, setSelectedFilterKey] = useState(
    accessibleFilterOptions.getIn([0, "key"])
  );

  const selectedFilter = accessibleFilterOptions.find(
    (v) => v.get("key") === selectedFilterKey
  );

  return (
    <div className="contentPicker">
      {accessibleFilterOptions.count() > 1 && (
        <Form>
          <FormGroup>
            <ControlLabel>Select District/Geography:</ControlLabel>
            <FormControl
              componentClass="select"
              value={selectedFilterKey}
              placeholder="select"
              onChange={(e) => setSelectedFilterKey(e.target.value)}
              onBlur={(e) => setSelectedFilterKey(e.target.value)}
            >
              {accessibleFilterOptions.map((opt) => (
                <option key={opt.get("key")} value={opt.get("key")}>
                  {opt.get("key")}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        </Form>
      )}
      {selectedFilter && (
        <TableauViz
          view={view}
          orgId={selectedFilter.get("orgId").toString()}
          filters={selectedFilter.get("filters", Map())}
          parameters={selectedFilter.get("parameters", Map())}
          tableauOptions={tableauOptions}
        />
      )}
    </div>
  );
};

export default FilterableTableauViz;
